'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { metaPixelTrack } from '@/lib/meta-pixel';

export function MetaPixelPageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const skippedInitialPageView = useRef(false);

  useEffect(() => {
    if (!skippedInitialPageView.current) {
      skippedInitialPageView.current = true;
      return;
    }

    // App Router is a SPA; Meta Pixel needs manual PageView on client-side navigation.
    metaPixelTrack('PageView');
  }, [pathname, search]);

  return null;
}
